<div *ngIf="!hideDocList">
    <div *ngIf="!emptyApprove && !purgeApproved && !purgeListEmpty">
        <div class="Tabletitle">
            <span> Purge List  ({{purgeList.length}}) </span>
        </div>

        <div class="row">
            <button *ngIf="allPurgeList" class="actionButton" mat-raised-button (click)="approvePurgeDocumentArray($event)">Approve Selected</button>
            <div class="input-group-sm mt-2 input-group col-6">
                <input *ngIf="allPurgeList" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
            </div>
            <!-- <mat-form-field class="element-filter" *ngIf="allPurgeList">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field> -->
        </div>

        <div *ngIf="allPurgeList" class="table-container mat-elevation-z8">
            <table mat-table matSort [dataSource]="allPurgeList" aria-describedby="purge-table" matSortActive="disposition_date" matSortDirection="asc">

                <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition"
    -->
                <ng-container matColumnDef="select">
                    <th id="select" mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Retention Group Name </th>
                    <td mat-cell *matCellDef="let purgeList"> {{purgeList.name}}</td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th id="docName" mat-header-cell *matHeaderCellDef mat-sort-header> Document Title </th>
                    <td mat-cell *matCellDef="let purgeList"> {{purgeList.title}} </td>
                </ng-container>

                <ng-container matColumnDef="disposition_date">
                    <th id="date" mat-header-cell *matHeaderCellDef mat-sort-header> Disposition Date </th>
                    <td mat-cell *matCellDef="let purgeList"> {{purgeList.disposition_date | date}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th id="actions" class="mat-header-sortless" *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let purgeList">
                        <button class="mr-1" mat-stroked-button aria-label="View" (click)="getDocDetails($event, purgeList.document_id)" style="font-size: 15px; height: 25px;text-align: center;line-height: 20px;">
                            <!-- <mat-icon>edit</mat-icon> -->View
                        </button>
                        <button mat-stroked-button aria-label="Approve" (click)="approvePurgeDocument($event, purgeList.document_id)" style="font-size: 15px; height: 25px; text-align: center;line-height: 20px;">
                            <!-- <mat-icon>edit</mat-icon> -->Approve
                        </button>
                    </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
        </div>
    </div>

    <div *ngIf="emptyApprove && !purgeApproved" class="card p-2">
        <div style="text-align: center;">
            Please select documents to approve for purge.
        </div>
        <div>
            <button class="button-class" mat-raised-button (click)="back()">Back</button>
        </div>
    </div>
    <div *ngIf="!emptyApprove && purgeApproved" class="card p-2">
        <div style="text-align: center;">
            Purge Approved.
        </div>
        <div>
            <button class="button-class" mat-raised-button (click)="back()">Back</button>
        </div>
    </div>
    <div *ngIf="purgeListEmpty" class="text-center">
        No documents to approve for purge.
    </div>
</div>

<div *ngIf="documentId && hideDocList">
    <app-display-search-doc [selectedDocument]="documentId" (hideDocList)="onHideDocList($event)">
    </app-display-search-doc>
    <!-- <app-filedetails [documentID]="documentId" (hideDocList)="onHideDocList($event)">
    </app-filedetails> -->
</div>